import React, { useEffect } from 'react'

import resetimage from '../../assets/reset-password.svg'
import { useRef } from 'react'
import { useState } from 'react'
import TextField from '@mui/material/TextField';
import ENDPOINT from '../../data/ENDPOINT'
import { Modal, Button, Toast, Form } from 'react-bootstrap'
import axios from 'axios';
import SecurityHeaders from '../../data/SecurityHeaders';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import SetPage from '../../data/SetPage';
import OTPInput from 'react-otp-input';
const PasswordChange = ({ props }) => {

  const { user } = useContext(AuthContext)

  const [email, setemail] = useState(null)
  const [password, setpassword] = useState(null)
  const [confpassword, setconfpassword] = useState(null)
  const [sendCode, setSenCode] = useState(false)
  const [toast, settoast] = useState(false);
  const [input, setinput] = useState(false)
  const [otp, setOtp] = useState('');
  const [toastTitle, settoastTite] = useState(null);
  const [toastMessage, settoastMessage] = useState(null);


  const closeToast = () => {
    settoast(false);
  }

  const ResetPassword = async (e) => {
    setinput(true)
    e.preventDefault()

    const data = new FormData()
    data.append("session", user.SessionId)
    const res = await axios.post(ENDPOINT + "user-password-reset-otp.php", data, SecurityHeaders)

    if (res) {
      //  //console.log("otp sending "+JSON.stringify(res))
      if (res.data[0].status === "success") {
        setotpsent(true)
        setinput(false)
        setemail(res.data[0].phone)
        settoastTite("Success !");
        settoastMessage("OTP sent");
        settoast(true);
      } else {
        settoastTite("Sending OTP failed !");
        settoastMessage("Please try again");
        settoast(true);
        setinput(false)
      }
    }


  };


  const changePassword = async (e) => {
    setSenCode(true)
    e.preventDefault()
    fetch(`${ENDPOINT}change-pasword.php?password=${password}&code=${otp}&session=${user.SessionId}`)

      .then(r => r.json())
      .then(result => {

        if (result[0].status === "success") {
          setotpsent(false)
          settoastTite("Password Changed !");
          settoastMessage("Login into your account");
          settoast(true);
          window.location.replace("/dashboard");
        }
        else if ((result[0].status === "error") && (result[0].message === "invalid otp")) {
          setotpsent(false)
          settoastTite("Invalid OTP !");
          settoastMessage("Please enter correct OTP");
          settoast(true);
        }
        else if ((result[0].status === "error") && (result[0].message === "reset error")) {
          setotpsent(false)
          settoastTite("Something went wrong !");
          settoastMessage("Please try again");
          settoast(true);
        }
        else {
          setotpsent(false)
          settoastTite("Something went wrong !");
          settoastMessage("Please try again");
          settoast(true);
        }

      })

  };


  useEffect(() => {
    SetPage("Change Password")
  }, [])

  const [otpsent, setotpsent] = useState(false)

  return (
    <>

      <div className="w-100 min-vh-100">


        <div className="flex-wrap d-flex pt-5 pb-5 justify-content-center min-vh-100">

          <div className="col-lg-5 col-md-4 col-sm-5 text-center">
            <img src={resetimage} className="col-lg-9 col-md-10 col-sm-9 col-7" alt=""></img>

          </div>


          <div className="col-lg-3 sm-p-15 col-md-4 col-sm-5 col-12">

            <div>
              <h5 className='text-center' >Change Password</h5>

            </div>
            {
              otpsent ? <></> :
                <div className='d-flex justify-content-center mt-3' >
                  <button onClick={ResetPassword} className='btn btn-primary form-control'>
                    {input?"OTP Sending...":"Send OTP"}
                  </button>
                </div>
            }

            {otpsent ?
              <>
                <form onSubmit={(e) => changePassword(e)}>

                  <p>Please enter the otp been sent to {email} to change your password</p>
                  <div className='d-flex justify-content-center mb-3 '>
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      renderSeparator={<span className='' />}
                      renderInput={(props) => <input {...props} className='otp-input' />}
                    />
                  </div>



                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control type="password" value={password} onChange={(e) => setpassword(e.target.value)} placeholder="New Password" minLength={6} maxLength={30} required />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control type="password" value={confpassword} onChange={(e) => setconfpassword(e.target.value)} placeholder="Confirm New Password" minLength={6} maxLength={30} required />
                  </Form.Group>



                  <Button variant="primary" type="submit" className="w-100" >
                   
                 {sendCode?" Changing Password...":"Change Password"}
                  </Button>
                </form>
              </> :
              <></>}






          </div>


        </div>

















        <div className="position-absolute fixed-bottom justify-center justify-content-center right-0 toast-container">

          <div className="mb-2 col-lg-3 col-md-3 col-sm-4 col-10">

            <Toast show={toast} onClose={closeToast} delay={5000} autohide className="space-between bg-warning">
              <Toast.Header>
                <img
                  src="holder.js/20x20?text=%20"
                  className="rounded me-2"
                  alt=""
                />
                <strong className="me-auto">{toastTitle}</strong>

              </Toast.Header>
              <Toast.Body>{toastMessage}</Toast.Body>
            </Toast>
          </div>


        </div>



      </div>
    </>
  )
}

export default PasswordChange
